/**
 * Map dimensions MUST be equal — the iso renderer (and especially the
 * minimap rhombus) assume a square (col == row) world. The constant below
 * is the single source of truth; `MAP_COLS` and `MAP_ROWS` are aliases so
 * existing code keeps reading them. Don't break this invariant or the
 * minimap and iso math will be wrong.
 */
export const MAP_SIZE = 96;
export const MAP_COLS = MAP_SIZE;
export const MAP_ROWS = MAP_SIZE;

export const TILE_W = 64;
export const TILE_H = 32;

export const SIM_HZ = 10;
export const SIM_DT_MS = 1000 / SIM_HZ;

export const STARTING_WOOD = 150;
export const STARTING_FOOD = 150;
export const STARTING_STONE = 50;
export const STARTING_GOLD = 0;
export const STARTING_IRON = 0;
export const STARTING_COAL = 0;
/** Small starter steel pool so the first spearman is reachable before a huta. */
export const STARTING_STEEL = 20;
export const STARTING_POP_CAP = 5;
export const POP_CAP_PER_HOUSE = 5;
export const POP_CAP_MAX = 100;

export const PATHFIND_BUDGET_PER_TICK = 24;

/** Max Chebyshev distance settlers will auto-seek the next resource after
 *  their current target is depleted. Beyond this they go idle. */
export const GATHER_SEARCH_RADIUS = 5;

export const CAMERA_EDGE_PX = 24;
export const CAMERA_SPEED_PX_PER_SEC = 700;
/** Height of the bottom HUD bar — camera viewport excludes this strip. */
export const HUD_BOTTOM_PX = 200;

export const SELECTION_RING_COLOR = 0xffffff;
export const HP_BAR_W = 28;
export const HP_BAR_H = 3;
